import { useEffect, useState } from "react"
import apiSafibc from "../../axios/axios"
import { Box, Button, Modal, TextField } from "@mui/material"
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import { useLoginStore } from "../../store/zustend";


const styleCi = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '75%'
};

const ModalEditAhorrador = ({ open, onClose, ahorrador }) => {

    const [nombre, setNombre] = useState('')
    const [paterno, setPaterno] = useState('')
    const [materno, setMaterno] = useState('')
    const [correo, setCorreo] = useState('')
    const [celular, setCelular] = useState('')
    const [rfc, setRfc] = useState('')
    const [homo, setHomo] = useState('')
    const [jsonModificacion, setJsonModficiacion] = useState({})
    const [fechaNacimiento, setFechaNacimiento] = useState('')

    const { loginStore } = useLoginStore()

    const buscarInfoAhorrador = () => {

        const infoAhorrador = async () => {

            try {

                const ida = btoa(ahorrador.id_ahorrador)

                const info = await apiSafibc(`/ahorradores/info-ahorrador/${ida}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setNombre(info.data.nombre)
                setPaterno(info.data.paterno)
                setMaterno(info.data.materno)
                setCorreo(info.data.correo)
                setCelular(info.data.cel)
                setRfc(info.data.rfc)
                setHomo(info.data.homoclave)
                setFechaNacimiento(info.data.fecha_nacimiento)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        infoAhorrador()

    }

    useEffect(() => {
        buscarInfoAhorrador()
    }, [])


    const modificarAhorrador = () => {


        const modifAhorrador = async () => {
            try {

                const ida = btoa(ahorrador.id_ahorrador)

                const info = await apiSafibc.post(`/ahorradores/modificar-ahorrador/${ida}`, jsonModificacion, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                toast.success(info.data.mensaje, toast_config)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }



        modifAhorrador()


    }

    const leerModificacion = (e) => {

        const { name, value } = e.target

        switch (name) {
            case 'nombre':
                setNombre(value.toUpperCase());
                break;
            case 'paterno':
                setPaterno(value.toUpperCase());
                break;
            case 'materno':
                setMaterno(value.toUpperCase());
                break;
            case 'correo':
                setCorreo(value.toUpperCase());
                break;
            case 'rfc':
                setRfc(value.toUpperCase());
                obtenerFechaNacimeinto()
                break;
            case 'homoclave':
                setHomo(value.toUpperCase());
                break;
            case 'cel':
                setCelular(value);
                break;
            // agrega más según lo necesites
            default:
                break;
        }


        setJsonModficiacion({
            ...jsonModificacion,
            [name]: value.toUpperCase()
        })

        console.log(value)

        //FALTA QUE MIENTRAS ESCRIBA SE MODIFIQUE

        //MANDAR A MODIFICAR LA INFO QUE SOLO MODIFICO

        //WARNING DE CONTRATOS PRONTOS A PAGAR

        //GRAFICOS PARA LOS AHORRADORES

    }

    const obtenerFechaNacimeinto = (rfc) => {
        if (rfc >= 10) {
            const anio = rfc.substr(4, 2)
            const mes = rfc.substr(6, 2)
            const dia = rfc.substr(8, 2)

            const anio_completo = parseInt(anio, 10) < 30 ? `20${anio}` : `19${anio}`

            const fn = `${anio_completo}-${mes.padStart('2', '0')}-${dia.padStart('2', '0')} 12:00:00`

            const fnd = new Date(fn)

            setFechaNacimiento(`${fnd.getFullYear()}-${(fnd.getMonth() + 1).toString().padStart('2', '0')}-${fnd.getDate().toString().padStart('2', '0')}`)
        }
    }

    return (
        <>
            <Modal
                open={open} onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleCi}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card'>
                        <div className='card-header text-center'>
                            <h3>Modificar Ahorrador</h3>
                        </div>
                        <div className='card-body'>
                            <div className="row mb-3">
                                <div className="col-md-4">

                                    <TextField onChange={leerModificacion} variant="standard" name="nombre" value={nombre} fullWidth placeholder="Nombre" label="Nombre" />
                                </div>
                                <div className="col-md-4" >
                                    <TextField onChange={leerModificacion} variant="standard" name="paterno" value={paterno} fullWidth placeholder="Apellido materno" label='Paterno' />
                                </div>
                                <div className="col-md-4" >
                                    <TextField onChange={leerModificacion} variant="standard" name="materno" value={materno} fullWidth placeholder="Apellido materno" label='Materno' />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <TextField onChange={leerModificacion} variant="standard" name="correo" value={correo} fullWidth placeholder="Correo" label='Correo' />
                                </div>
                                <div className="col-md-4">
                                    <TextField onChange={leerModificacion} inputProps={{ maxLength: 10 }} variant="standard" name="cel" value={celular} fullWidth placeholder="Celular" label='Celular' />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <TextField onChange={leerModificacion} variant="standard" name="rfc" inputProps={{ maxLength: 10 }} value={rfc} fullWidth placeholder="Rfc" label='Rfc' />
                                </div>
                                <div className="col-md-4">
                                    <TextField onChange={leerModificacion} variant="standard" name="homoclave" inputProps={{ maxLength: 3 }} value={homo} fullWidth placeholder="Homoclave" label='Homoclave' />
                                </div>
                                <div className='col-md-4'>
                                    <TextField type="date" value={fechaNacimiento} disabled name='fecha_nacimiento' className="mb-2" label="dd/mm/aaaa" variant="standard" style={{ 'width': '95%' }} />
                                </div>
                            </div>
                            <Button variant="outlined" onClick={modificarAhorrador}>Modificar</Button>
                        </div>
                    </div>
                </Box>

            </Modal>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

        </>
    )

}

export default ModalEditAhorrador